import LegalPage from './LegalPage';
import { COMPANY } from './legalConstants';

export default function Contact() {
  return (
    <LegalPage title="Contact" testId="legal-page-contact">
      <h2>Bedrijfsgegevens</h2>
      <ul>
        <li><strong>Handelsnaam</strong>: {COMPANY.tradeName}</li>
        <li>
          <strong>Rechtsvorm en juridische benaming</strong>:{' '}
          {COMPANY.legalName}
        </li>
        <li>
          <strong>Adres</strong>: {COMPANY.address.street},{' '}
          {COMPANY.address.postalCode} {COMPANY.address.city},{' '}
          {COMPANY.address.country}
        </li>
        <li>
          <strong>Ondernemingsnummer / BTW</strong>: {COMPANY.vatNumber}
        </li>
        <li><strong>{COMPANY.rpr}</strong></li>
      </ul>

      <h2>Klantendienst</h2>
      <p>
        Voor vragen over bestellingen, leveringen, retours,
        herroepingsrecht of productinformatie kan u ons bereiken via
        e-mail:
      </p>
      <p>
        <a
          data-testid="contact-email-link"
          className="text-base font-medium underline"
          href={`mailto:${COMPANY.email}`}
        >
          {COMPANY.email}
        </a>
      </p>
      <p className="text-sm text-muted-foreground">
        Wij streven ernaar om binnen 2 werkdagen te antwoorden.
      </p>

      <h2>Telefoon</h2>
      <p data-testid="contact-no-phone-note">
        <strong>The Herborist is op dit ogenblik niet telefonisch
        bereikbaar.</strong> Alle communicatie verloopt via e-mail
        zodat we elk dossier traceerbaar kunnen opvolgen.
      </p>

      <h2>Klachten en geschillen</h2>
      <p>
        Klachten kan u steeds eerst aan ons richten via{' '}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>. Komen
        wij er samen niet uit, dan kan u als consument een geschil
        ook online voorleggen aan het Europees{' '}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
        >
          ODR-platform
        </a>
        .
      </p>
    </LegalPage>
  );
}
